<template>
  <BaseCard :heading="filters.capitalize($t('global.items.appointment', 2))">
    <Flex direction="column">
      <Flex
        v-for="appointment in appointments"
        :key="appointment.id"
        align="center"
        justify="between"
        v-test="'sale-appointment'"
      >
        <BaseText>{{ appointment.serviceNames }}</BaseText>
        <BaseText>{{ filters.dateTime(appointment.startAt) }}</BaseText>
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import filters from '@/filters';
import type { Appointment } from '@/types';

defineProps<{
  appointments: Appointment[];
}>();
</script>
